import { z } from "zod";
import models from "./hull-models-20261027.json" with { type: "json" };

export const HULL_MODEL_VERSION = "ships-20261027-v2";
export const HULL_FAMILIES = [
  "assault",
  "interceptor",
  "engineer",
  "scout",
  "transport",
] as const;
export type HullFamily = (typeof HULL_FAMILIES)[number];
export const HULL_MODEL_IDS = [
  ...HULL_FAMILIES,
  "bastion",
  "hawk",
  "aerie",
  "arrow",
  "argosy",
  "leviathan",
  "quicksilver",
  "falcon",
  "clipper",
  "behemoth",
] as const;
export type HullModelId = (typeof HULL_MODEL_IDS)[number];
export const hullModelIdSchema = z.enum(HULL_MODEL_IDS);
const modelSchema = z
  .strictObject({
    family: z.enum(HULL_FAMILIES),
    tier: z.union([z.literal(1), z.literal(2), z.literal(3)]),
    name: z.string().min(1).max(50),
    sourceModel: z.string().min(1).max(50),
    equipmentSlots: z.number().int().min(4).max(11),
    credits: z.string().regex(/^(0|[1-9]\d*)$/),
    components: z.number().int().nonnegative(),
  })
  .readonly();
export const HULL_MODELS = z
  .record(hullModelIdSchema, modelSchema)
  .readonly()
  .parse(models);
